






























































import VueOptions from '@utils/VueOptions'
import CalendarService from '@services/CalendarService'
import LoadingIndicator from '@components/LoadingIndicator'
import EventResourceList from '@ui/Campaign/pipeline/EventFeed/EventResourceList.vue'

settings =
  name: 'SharedCampaignShow'

  resources:
    shared_campaign:
      resourceName: 'shared_campaign'
      slug: 'open/shared_campaigns/:campaignId'
      infinityScroll: false

  vue:
    components: {
      LoadingIndicator,
      EventResourceList,
    }

    computed:
      campaign: -> @shared_campaign
      campaignCreatives: -> @campaign?.creatives || {}
      campaignHasProductSampling: -> Object.keys(@campaignCreatives || []).includes('product_sampling')
      campaignHasOnsiteSpace: -> Object.keys(@campaignCreatives || []).includes('onsite_space')
      audienceListingsPerSegment: ->
        return [] unless @campaign?.audience_listings
        listings = {}
        for listing in @campaign.audience_listings
          for spaceKey, space of listing.spaces
            l = JSON.parse(JSON.stringify(listing))
            l.segment = space.segment
            key = "#{l.id}:#{space.segment}"
            l.calendar_events = CalendarService.normalizeEvents l.calendar_events
            hasProductSampling = space.type is 'product_sampling' and @campaignHasProductSampling
            hasOnsiteActivation = space.type is 'onsite_activation' and @campaignHasOnsiteSpace
            listings[key] = l if hasProductSampling || hasOnsiteActivation
        Object.values listings

      tags: ->
        ['food_products', 'food_distribution']

      gridItems: ->
        [
          {
            iconClass: 'fas fa-gifts',
            title: 'Truffle Crumb Cakes',
            description: 'MRSP - $5.00<br>Single Serving',
          },
          {
            iconClass: 'fas fa-temperature-high',
            title: 'Temperature',
            description: 'Served Cold',
          },
          {
            iconClass: 'fas fa-id-card',
            title: 'Age Restrictions',
            description: 'No age restrictions',
          },
          {
            iconClass: 'fas fa-map-marked-alt',
            title: 'Target Location ',
            tags: ['DMA: Los Angeles'],
          },

          {
            iconClass: 'fas fa-wrench',
            title: 'Assembly',
            description: 'No assembly required',
          },
          {
            iconClass: 'fas fa-boxes',
            title: 'Storage Requirements',
            description: 'Cold storage available',
          },
          {
            iconClass: 'fas fa-comment-dots',
            title: 'Special Requests',
            description: '-',
          },
          {
            iconClass: 'fas fa-user-check',
            title: 'Target Audience',
            description: 'Any Audience',
          },

          {
            iconClass: 'fas fa-id-card',
            title: 'Target Categories',
            tags: ['at_work'],
          },
          {
            iconClass: 'fas fa-user-check',
            title: 'Target Activities',
            description: 'Any Activity',
          },
          {
            iconClass: 'fas fa-map-marker-alt',
            title: 'Target within 5 mi. of',
            tags: ['whole_foods', 'target'],
          },
          {
            iconClass: 'fas fa-clipboard-list',
            title: 'Target Listing Types',
            tags: ['community_service'],
          },
        ]

export default VueOptions.vue settings

